import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { MerchantAuthProvider } from './contexts/MerchantAuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MerchantProtectedRoute from './components/MerchantProtectedRoute';
import HomePage from './pages/HomePage';
import ProximamentePage from './pages/ProximamentePage';
import PaymentPage from './pages/PaymentPage';

// Admin Panel
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import OrdersPage from './pages/admin/OrdersPage';
import BalancePage from './pages/admin/BalancePage';
import SettingsPage from './pages/admin/SettingsPage';

// Merchant Portal
import MerchantLoginPage from './pages/merchant/MerchantLoginPage';
import MerchantRegisterPage from './pages/merchant/MerchantRegisterPage';
import MerchantDashboardPage from './pages/merchant/MerchantDashboardPage';
import MerchantOrdersPage from './pages/merchant/MerchantOrdersPage';
import MerchantSettingsPage from './pages/merchant/MerchantSettingsPage';
import MerchantWebhooksPage from './pages/merchant/MerchantWebhooksPage';

import './App.css';

export default function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <MerchantAuthProvider>
        <Router>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/proximamente" element={<ProximamentePage />} />
            <Route path="/payment/:orderId" element={<PaymentPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/login" element={<Navigate to="/portal/login" replace />} />
            
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/orders"
              element={
                <ProtectedRoute>
                  <OrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/balance"
              element={
                <ProtectedRoute>
                  <BalancePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            
            {/* Merchant Portal Routes */}
            <Route path="/portal/login" element={<MerchantLoginPage />} />
            <Route path="/portal/register" element={<MerchantRegisterPage />} />
            
            <Route
              path="/portal/dashboard"
              element={
                <MerchantProtectedRoute>
                  <MerchantDashboardPage />
                </MerchantProtectedRoute>
              }
            />
            <Route
              path="/portal/orders"
              element={
                <MerchantProtectedRoute>
                  <MerchantOrdersPage />
                </MerchantProtectedRoute>
              }
            />
            <Route
              path="/portal/settings"
              element={
                <MerchantProtectedRoute>
                  <MerchantSettingsPage />
                </MerchantProtectedRoute>
              }
            />
            <Route
              path="/portal/webhooks"
              element={
                <MerchantProtectedRoute>
                  <MerchantWebhooksPage />
                </MerchantProtectedRoute>
              }
            />
            <Route path="/portal" element={<Navigate to="/portal/dashboard" replace />} />
          </Routes>
        </Router>
      </MerchantAuthProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}